module.exports = __webpack_public_path__ + "static/NeueMontreal-BoldItalic-eef29697d2b03245439c2e7eea9913d7.woff2";